// extracted by mini-css-extract-plugin
export default {"outer":"Section_outer__HueAC","inner":"Section_inner__TZfka","bg-white":"Section_bg-white__kdiPj","bg-off-white":"Section_bg-off-white__RANjP"};